import { _coupons } from "../constants/api";

export const fetchCoupons = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_coupons}`, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch coupons: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in fetchBanners API ==> ', error);
    throw error;
  }
};

export const createCoupons = async (data) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    const token = userData?.token;
    console.log("data: ",data)

    if (!token) {
      throw new Error('Token not found');
    }

    

    const response = await fetch(`${_coupons}/create`, {
      method: "POST",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Failed to create coupons: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in create coupons API ==> ', error);
    throw error;
  }
};

export const updateCoupons = async (id, image) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const formData = new FormData();
    formData.append("image", image);

    const response = await fetch(`${_coupons}/${id}`, {
      method: "PUT",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Failed to update coupons: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in updateBanner API ==> ', error);
    throw error;
  }
};

export const deleteCoupons = async (id) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_coupons}/${id}`, {
      method: "DELETE",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete coupons: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in delete coupons API ==> ', error);
    throw error;
  }
};
